var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"tiptap-emoji-icon",on:{"mousedown":function($event){$event.preventDefault();},"click":_vm.handleClick}},[_c('md-icon',[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }